module.exports = __webpack_public_path__ + "img/manage.defe3b40.png";